import React, { useCallback } from 'react';
import { jumpToPageByH5 } from '@/utils/fn';
import { reportClick } from '@/utils/report';
import styles from '../index.less';

const AllIncomeSummary = ({ pageName, calClick, summaryData }) => {
  const renderYIncomeVal = useCallback(() => {
    // 是否计算中
    if (summaryData?.ic) {
      return <em>计算中...</em>;
    }
    // 同时有现金和云豆收益
    if (summaryData?.yic > 0 && summaryData?.yicb > 0) {
      return (
        <>
          <div>
            <em>+{summaryData.yic}</em> <span className={styles.valUnit}>元</span>
          </div>
          <em>+{summaryData.yicb}</em> <span className={styles.valUnit}>云豆</span>
        </>
      );
    }
    // 只有现金收益
    if (summaryData?.yic > 0) {
      return (
        <>
          <em>+{summaryData.yic}</em> <span className={styles.valUnit}>元</span>
        </>
      );
    }
    // TODO：什么时候显示+号，还有什么0要显示。只有云豆收益
    if (summaryData?.yicb >= 0) {
      return (
        <>
          <em>
            {summaryData.yicb > 0 && '+'}
            {summaryData.yicb}
          </em>
          {summaryData.yicb > 0 && <span className={styles.valUnit}>云豆</span>}
        </>
      );
    }
  }, [summaryData.ic, summaryData.yic, summaryData.yicb]);

  const handleJumpToBalanceSummary = useCallback(() => {
    reportClick({
      page_name: pageName,
      button_name: 'goto_my_wallet',
    });
    jumpToPageByH5('/wallet/balance/summary');
  }, [pageName]);

  const handleJumpToWxmall = useCallback(() => {
    reportClick({
      page_name: pageName,
      button_name: 'goto_wxmall',
    });
    jumpToPageByH5('/wxMall/home');
  }, [pageName]);

  const handleCalClick = useCallback(() => {
    reportClick({
      page_name: pageName,
      button_name: 'all_cumulative_income',
    });
    calClick();
  }, [calClick, pageName]);

  return (
    <div className={styles.allIncomeSummaryHeader}>
      <div onClick={handleCalClick} className={styles.totalIncome}>
        <div className={styles.title}>累计收益</div>
        <div className={styles.amount}>{summaryData?.ti}</div>
        <div className={styles.breakdown}>
          {/* TODO, summaryData?.ticb是0的时候，还有显示0/100吗？*/}
          累计云豆{summaryData?.ticb}/100
          {summaryData?.tic > 0 && <span>+ 累计现金{summaryData?.tic}</span>}
        </div>
      </div>
      {/* TODO 都是跳转到哪些页面src/pages/wallet/balance/summary,昨日收益这里点击要跳转吗 */}
      <div className={styles.metricsContainer}>
        <div className={styles.metric}>
          <div className={styles.label}>昨日收益</div>
          <div className={styles.value}>{renderYIncomeVal()}</div>
        </div>
        <div className={styles.metric}>
          <div className={styles.label}>可提现余额(元)</div>
          <div className={styles.value}>{summaryData?.cb}</div>
        </div>
        <div className={styles.metric}>
          <div className={styles.label}>云豆余额(个)</div>
          <div className={styles.value}>{summaryData?.cbb}</div>
        </div>
        {/* // TODO: 全量改回来箭头跳转 */}
        {/* <div className={styles.metric} onClick={handleJumpToBalanceSummary}>
          <div className={styles.label}>可提现余额(元)</div>
          <div className={styles.value}>{summaryData?.cb}</div>
        </div>
        <div className={styles.metric} onClick={handleJumpToWxmall}>
          <div className={styles.label}>云豆余额(个)</div>
          <div className={styles.value}>{summaryData?.cbb}</div>
        </div> */}
      </div>
    </div>
  );
};
export default AllIncomeSummary;
